import { atom, useAtomValue, useSetAtom } from "jotai";
import { atomWithImmer } from "jotai-immer";

interface OverlayModal {
  id: string;
  closeOnClickOutside: boolean;
}

const overlayAtom = atomWithImmer<{
  // Manually opened overlay (e.g. mobile sidebar)
  isOpen: boolean;
  closeOnClickOutside?: boolean;
  // Every Modal that is currently shown registers itself here, so one modal
  // closing can never hide the overlay of another modal that is still open
  modals: OverlayModal[];
}>({
  isOpen: false,
  closeOnClickOutside: true,
  modals: [],
});

const overlayStateAtom = atom((get) => {
  const { isOpen, closeOnClickOutside, modals } = get(overlayAtom);
  const topModal = modals[modals.length - 1];
  return {
    isOpen: isOpen || modals.length > 0,
    closeOnClickOutside: topModal
      ? topModal.closeOnClickOutside
      : closeOnClickOutside,
  };
});

export const useSetOverlayAtom = () => useSetAtom(overlayAtom);

const useOverlayAtom = () => {
  const state = useAtomValue(overlayStateAtom);
  const setOverlay = useSetOverlayAtom();
  return [state, setOverlay] as const;
};

export default useOverlayAtom;
